import { render, staticRenderFns } from "./aw.vue?vue&type=template&id=9d6e20d6&scoped=true&"
import script from "./aw.vue?vue&type=script&lang=js&"
export * from "./aw.vue?vue&type=script&lang=js&"
import style0 from "./aw.vue?vue&type=style&index=0&id=9d6e20d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d6e20d6",
  null
  
)

export default component.exports